import { COMPONENT_IDS } from "../storage2ComponentIDs";
class HeightRestrictedComponent {
    constructor(heightRestriction) {
        this.heightRestriction = heightRestriction;
        this.typeId = HeightRestrictedComponent.id;
        this.doStoreInSnapshot = false;
        this.serializable = false;
    }
    eq(other) {
        return other.heightRestriction === this.heightRestriction;
    }
}
HeightRestrictedComponent.id = COMPONENT_IDS.HEIGHT_RESTRICTED_COMPONENT;
export default HeightRestrictedComponent;
